import React, { useEffect, useState } from "react";

export const PhotoCarousel = ({ slides, interval = 3000, testId = "photo-carousel" }) => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const timer = setInterval(() => setIndex((i) => (i + 1) % slides.length), interval);
    return () => clearInterval(timer);
  }, [paused, interval, slides.length]);

  return (
    <div
      className="relative rounded-md overflow-hidden border border-ei-mist bg-ei-navy"
      data-testid={testId}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="relative aspect-[4/3] sm:aspect-[16/9]">
        {slides.map((slide, i) => (
          <figure
            key={slide.caption}
            className={`absolute inset-0 transition-opacity duration-500 ${i === index ? "opacity-100" : "opacity-0"}`}
            aria-hidden={i !== index}
          >
            <img src={slide.src} alt={slide.caption} className="w-full h-full object-cover object-[center_25%]" loading={i === 0 ? "eager" : "lazy"} />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ei-navy/95 to-transparent px-5 pt-12 pb-5 sm:px-8 sm:pb-7">
              <span className="font-display text-base md:text-lg font-semibold text-ei-white" data-testid={`${testId}-caption`}>
                {slide.caption}
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
      <div className="absolute top-3 right-3 flex gap-2">
        {slides.map((slide, i) => (
          <button
            key={slide.caption}
            type="button"
            onClick={() => setIndex(i)}
            aria-label={`Show photo ${i + 1}`}
            data-testid={`${testId}-dot-${i}`}
            className={`w-2.5 h-2.5 rounded-full transition-colors ${i === index ? "bg-ei-gold" : "bg-ei-white/50 hover:bg-ei-white/80"}`}
          />
        ))}
      </div>
    </div>
  );
};
